import { render, staticRenderFns } from "./DeviceStatus.vue?vue&type=template&id=610487b6&scoped=true"
import script from "./DeviceStatus.vue?vue&type=script&lang=js"
export * from "./DeviceStatus.vue?vue&type=script&lang=js"
import style0 from "./DeviceStatus.vue?vue&type=style&index=0&id=610487b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610487b6",
  null
  
)

export default component.exports